import {
  Input,
  FormControl,
  FormLabel,
  FormErrorMessage,
  Button,
  Box,
  Text,
  VStack,
  useToast,
  useColorModeValue,
  Container,
  Flex,
  useMediaQuery,
} from '@chakra-ui/react';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import { FORM_PADDING_TOP_XL } from '../../utils/consts';
import { useContext } from 'react';
import CustomToast from '../../common/CustomToast';
import ErrorToast from '../../common/ErrorToast';
import { HttpContext } from '../../context/HttpContext';
import { ArrowBackIcon } from '@chakra-ui/icons';
import { useNavigate } from 'react-router-dom';
import { trackingSearch } from '../../utils/trackingParams';

function ForgotPasswordPage() {
  const { publicAxios } = useContext(HttpContext);
  const toast = useToast();
  const modeText = useColorModeValue('secondaryDark08', '#DDDDDD');
  const navigate = useNavigate();
  const validationSchema = Yup.object().shape({
    email: Yup.string()
      .required('Please enter your email address')
      .email('Please enter a valid email address'),
  });
  const formOptions = {
    resolver: yupResolver(validationSchema),
    mode: 'onChange',
  };

  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting, isDirty, isValid },
    reset,
  } = useForm(formOptions);

  function onSubmit(values) {
    return new Promise((resolve) => {
      const data = {
        email: values.email,
      };

      publicAxios
        .post(`/send_reset_password_link`, data)
        .catch((onError) => {
          console.log(onError);
          toast({
            render: (props) => (
              <ErrorToast error={onError} onClose={props.onClose} />
            ),
          });
        })
        .finally(() => {
          toast({
            render: (props) => (
              <CustomToast
                status="success"
                title="Reset password."
                description="If you have an account, you'll receive an email with a reset link. Please check your inbox."
                onClose={props.onClose}
                id={props.id}
              />
            ),
          });

          reset();
        });
      resolve();
    });
  }

  return (
    <>
      <form onSubmit={handleSubmit(onSubmit)} w="100%">
        <VStack spacing={6} alignItems="flex-start">
          <VStack spacing={2} alignItems="flex-start" mb={4}>
            <Flex
              direction="row"
              w="100%"
              align="center"
              gap={1}
              cursor="pointer"
              justifyContent="flex-start"
              onClick={() => {
                navigate(`/${trackingSearch()}`);
              }}
              display={{ base: 'flex', md: 'none' }}
            >
              <ArrowBackIcon />
              <Text textStyle="headingFamilyMedium" fontSize="16px" mt={0.5}>
                Back
              </Text>
            </Flex>
            <Text textStyle="heading2">Forgot password?</Text>
            <Text textStyle="bodyMedium">
              Enter your e-mail address and we'll send you a link to reset your
              password.
            </Text>
          </VStack>
          <FormControl isRequired isInvalid={errors.email}>
            <FormLabel textStyle="bodyMedium" color="#666666">
              E-mail address
            </FormLabel>
            <Input
              id="email"
              type="email"
              placeholder="Your email address"
              {...register('email')}
              bg="white"
              borderRadius="12px"
              border="1px solid #D0D5DD"
              mt={1}
            />
            <FormErrorMessage mt={2}>
              {errors.email?.message || errors.email}
            </FormErrorMessage>
          </FormControl>
          <Box w="full">
            <Button
              type="submit"
              isLoading={isSubmitting}
              disabled={!isDirty || !isValid || isSubmitting}
              mt={4}
              alt="Send reset instructions"
            >
              Send link
            </Button>
          </Box>
        </VStack>
      </form>
    </>
  );
}

export default ForgotPasswordPage;
